import React from 'react'
import { InformationalDialog } from '@jarvis.oddle/core/components/Dialog'
import { TranslationContext } from '@jarvis.oddle/core/components/Translation'
import { makeControlledModal } from 'src/decorators/ModalController'

const RefreshModal = ({ modal }: {
  modal: {
    show: boolean
    onClose: () => void
    onClosed: () => void
  }
}) => {
  const { t } = React.useContext(TranslationContext)
  return (
    <InformationalDialog
      closeOnBackdropClick={false}
      closeOnEscapeKeyPress={false}
      {...modal}
      onConfirm={() => window.location.reload()}
      header={t('Oops')}
      body={t('Something went wrong. Please refresh this page to continue.')}
      confirmText={t('Refresh')}
    />
  )
}

export default makeControlledModal(RefreshModal, 'RefreshModal')
